import { useEffect } from 'react';
import { useSettings, DEFAULT_COLORS } from '../../providers/SettingsContext';

export const applyColors = (colors = {}) => {
  const c = { ...DEFAULT_COLORS, ...colors };
  const root = document.documentElement;
  root.style.setProperty('--color-primary', c.primary);
  root.style.setProperty('--color-primary-dark', c.primaryDark);
  root.style.setProperty('--color-bg', c.bg);
  root.style.setProperty('--color-text-main', c.textMain);
  root.style.setProperty('--color-text-secondary', c.textSecondary);
  root.style.setProperty('--color-price', c.price);
};

const GlobalColors = () => {
  const { settings } = useSettings();

  useEffect(() => {
    applyColors(settings?.colors);
  }, [settings]);

  return null;
};

export default GlobalColors;
